import { fetchContactsWithSameRole_old } from '../../../../../../services/contacts/fetchContactsWithSameRole_old'

interface ICheckDuplicated {
  partnerId: string
  contactId: string
  role: string
}

export const checkDuplicates = async ({ partnerId, contactId, role }: ICheckDuplicated) => {
  const result = await fetchContactsWithSameRole_old({ role, contactId, partnerId })
  return Boolean(result.length)
}
